module.exports = __webpack_public_path__ + "img/pr.3bdf1635.jpg";